import { useQuery } from '@tanstack/react-query'
import { cmApi } from '@/api/cmApi'
import { authHeaders } from '@/auth/session'
import { parseCurrencyType, type CurrencyType } from '@/features/hierarchy/hierarchy'

function useHierarchySelfCurrency() {
  return useQuery({
    queryKey: ['cm', 'hierarchy', 'self'],
    queryFn: () => cmApi.hierarchySelf(authHeaders()),
    staleTime: 60_000,
  })
}

/** Logged-in node Lab currency. Books stay INR; convert at the edge. */
export function useViewerCurrency(): CurrencyType {
  const self = useHierarchySelfCurrency()
  return parseCurrencyType(self.data?.node.currencyType)
}

/** Raw Lab currencyType string (keeps POINT@1; not collapsed to POINTS). */
export function useViewerCurrencyRaw(): string {
  const self = useHierarchySelfCurrency()
  return String(self.data?.node.currencyType ?? 'INR')
}
